import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IInvoice,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  invoice?: IInvoice;
};

export function getWorkLogPayeeStatusCellProps({
  workLog,
  invoice
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: invoice?.invoiceNumber
          ? `Invoiced #${invoice.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    case WorkLogStatus.InProgress:
      return {
        secondaryText: "Returned for editing",
        secondaryTextColor: "amber400",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.InReview:
      return {
        secondaryText: "Awaiting client approval",
        pill: {
          text: "Submitted",
          theme: "blue",
          icon: "time"
        }
      };

    case WorkLogStatus.Rejected:
      return {
        secondaryText: workLog.invoiceId ? "Cancelled invoice" : "Not invoiced",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "alert-circle"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        secondaryText: "Awaiting your submission",
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
